var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var CitationIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 59
  }), React.createElement("path", {
    d: "M33.3913 8.34819V43.6178L25.2522 38.6091L20.8696 36.1047L16.487 38.6091L8.34783 43.6178V8.34819H33.3913ZM41.7391 0.000366211H0V58.4352L20.8696 45.9134L41.7391 58.4352V0.000366211Z"
  }));
};
export var CitationIconGlyph = function (props) {
  return React.createElement(CitationIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};